<script lang="ts">
    import type { Snippet } from 'svelte';
    import { cubicInOut } from 'svelte/easing';
    import { crossfade, fade } from 'svelte/transition';

    let {
        toggleAContent,
        toggleBContent,
    }: {
        toggleAContent?: Snippet;
        toggleBContent?: Snippet;
    } = $props();

    const ToggleValue = {
        A: 'A',
        B: 'B',
    } as const;
    type ToggleValue = (typeof ToggleValue)[keyof typeof ToggleValue];

    let toggleValue = $state<ToggleValue>(ToggleValue.A);

    const [send, receive] = crossfade({
        duration: 300,
        easing: cubicInOut,
    });
</script>

<div
    class="bg-white px-s py-m border border-solid border-border-quiet rounded-m flex flex-col gap-m absolute top-full left-0 right-0 overflow-hidden auto-height-anim w-full"
>
    <!-- Toggle Buttons -->
    <div
        class="flex gap-3xs rounded-full bg-container-quiet p-2xs items-center justify-center w-fit mx-auto"
        aria-label="Filter toggle"
    >
        <button
            class="relative z-10 rounded-full px-m py-xs flex gap-xs text-xs font-semibold"
            type="button"
            onclick={() => (toggleValue = ToggleValue.A)}
        >
            {#if toggleValue === ToggleValue.A}
                <span
                    in:receive={{ key: 'active-pill' }}
                    out:send={{ key: 'active-pill' }}
                    class="absolute inset-0 rounded-full bg-white border border-border-quiet shadow-sm"
                ></span>
            {/if}
            <span class="relative z-10">Rechercher</span>
        </button>

        <button
            class="relative z-10 rounded-full px-m py-xs flex gap-xs text-xs font-semibold"
            type="button"
            onclick={() => (toggleValue = ToggleValue.B)}
        >
            {#if toggleValue === ToggleValue.B}
                <span
                    in:receive={{ key: 'active-pill' }}
                    out:send={{ key: 'active-pill' }}
                    class="absolute inset-0 rounded-full bg-white border border-border-quiet shadow-sm"
                ></span>
            {/if}
            <span class="relative z-10">Filtrer</span>
        </button>
    </div>

    <div class="">
        {#if toggleValue === ToggleValue.A}
            <div in:fade={{ duration: 300 }}>
                {@render toggleAContent?.()}
            </div>
        {:else if toggleValue === ToggleValue.B}
            <div in:fade={{ duration: 300 }}>
                {@render toggleBContent?.()}
            </div>
        {/if}
    </div>
</div>

<style>
    /*
      This is the magic that allows transition: height
      to work with height: auto in modern browsers.
    */
    .auto-height-anim {
        interpolate-size: allow-keywords;
        height: auto;
        transition: height 300ms cubic-bezier(0.4, 0, 0.2, 1);
    }
</style>
